import React from 'react';
import AppRoutes from './config/AppRoutes';

function App() {
  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;
